import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  toast,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBIcon,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";
import InfoBox from "../components/InfoBox";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { set } from "date-fns";

const AddEditExpensesMain = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const [frm, setValues] = useState({
    code: props.code,

    expensecode: { value: "", label: "" },
    transactiondatetime: new Date(),
    usercode: sessionStorage.getItem("msal.uc"),
    deleted: false,
    amount: 0,
    remarks: "",
  });

  const [unitofmeasure, setUnitOfMeasure] = useState("");
  const [disabled, setDisabled] = useState("");

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });

    // if(objName==="itemcode")
    // {

    //     var str = selOption["label"];
    //     var sStart = str.lastIndexOf("<") + 1;
    //     var sEnd= str.lastIndexOf(">");
    //     var tmpunitofmeasure = str.substring(sStart, sEnd);
    //    console.log(tmpunitofmeasure);
    //    setUnitOfMeasure(tmpunitofmeasure.toUpperCase());
    // }
  };

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    saveexpensesmain();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalInfo, showInfoBox] = useState(false);

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  };

  const [expenseoptions, setexpenseoptions] = useState([]);
  const loadexpense = () => {
    Axios.get(serverURL + "/getexpenseoptions", bearer)
      .then((res) => {
        setexpenseoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const ClearFields = () => {
    setValues({
      ...frm,
      code: props.code,

      expensecode: { value: "", label: "" },

      transactiondatetime: new Date(),
      usercode: sessionStorage.getItem("msal.uc"),

      deleted: false,
      amount: 0,
      remarks: "",
    });
  };

  const loadtransactionexpensesmain = () => {
    if (props.code === "new") {
      setDisabled("");
      ClearFields();
      return;
    }
    setDisabled("disabled");
    Axios.get(
      serverURL + "/loadtransactionexpensesmain/?code=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setDisabled("disabled");
          setValues({
            ...frm,

            code: props.code,
            transactiondatetime: new Date(res.data.transactiondatetime),
            expensecode: {
              value: res.data.expensecode,
              label: res.data.expense,
            },
            amount: res.data.amount,
            deleted: res.data.deleted,
            remarks: res.data.remarks,
          });
        } else {
          ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const saveexpensesmain = () => {
    const data = frm;

    Axios.post(props.apiServer + "/saveexpensesmain", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          // notify(res.data.message);
          //  toast.info(res.data.message, {
          //     closeButton: false

          //   });
          //  props.showResult(res.data.message);
          props.refreshGrid(res.data.message);
        } else {
          toast.warning(res.data.message, {
            closeButton: false,
          });

          setErrorMessage(res.data.message);
          toggleWarningBox();
          console.log(res.data.message);
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [modalDelete, showDeleteBox] = useState(false);

  const deleteRecord = () => {
    if (props.code === "new") {
      setErrorMessage("Please select a record!");
      toggleWarningBox();

      return;
    }

    showDeleteBox(!modalDelete);
  };

  function confirmDelete() {
    removeSeedPlanting();

    showDeleteBox(!modalDelete);
  }

  const removeSeedPlanting = () => {
    const data = frm;

    Axios.post(props.apiServer + "/removeSeedPlanting", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          props.refreshGrid(res.data.message);
        } else {
          setErrorMessage(res.data.message);
          //  toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        //  toggleWarningBox();
      });

    //  props.refreshGrid(res.data.message);
  };

  useMountEffect(loadexpense);
  useMountEffect(checkAdminAccess);
  /* eslint-disable */

  useEffect(() => {
    loadtransactionexpensesmain();
  }, [props.code]);

  // useMountEffect(loadSeedPlanting);

  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          <form
            className="needs-validation"
            onSubmit={submitHandler}
            noValidate
          >
            <MDBRow hidden>
              <MDBInput value={frm.code} id="code" label="Code">
                <div className="invalid-feedback">This field is required!</div>
                <div className="valid-feedback"></div>
              </MDBInput>
            </MDBRow>

            <MDBRow>
              <MDBCol md="10">
                <label className="grey-text">
                  <small>&nbsp;Transaction Date</small>
                </label>
              </MDBCol>
            </MDBRow>

            {/* BirthDate */}
            <MDBRow>
              <MDBCol md="10">
                <DatePicker
                  placeholderText="mm/dd/yyyy"
                  selected={frm.transactiondatetime}
                  onChange={getDateValue("transactiondatetime")}
                />
                <br />
                <br />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="12">
                <label className="grey-text">
                  <small>&nbsp;Expense</small>
                </label>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="12">
                <Select
                  placeholderText="Select expense"
                  isSearchable
                  value={frm.expensecode}
                  onChange={handleChange("expensecode")}
                  options={expenseoptions}
                  required
                  className={disabled}
                />

                <div className="invalid-feedback ">This field is required!</div>
                <div className="valid-feedback"></div>

                <br />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="10">
                <MDBInput
                  value={frm.remarks}
                  id="remarks"
                  label="Remarks"
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="10">
                <MDBInput
                  value={frm.amount}
                  id="amount"
                  label="Amount"
                  type="number"
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>

            {frm.code === "new" ? (
              ""
            ) : (
              <React.Fragment>
                <MDBRow>
                  <MDBCol md="12">
                    <MDBInput
                      id="deleted"
                      label="Deleted"
                      type="checkbox"
                      checked={frm.deleted}
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>
              </React.Fragment>
            )}
            <MDBBtn className="blue lighten-1" type="submit">
              Save
            </MDBBtn>
            {props.code === "new" ? (
              <MDBBtn
                className="cloudy-knoxville-gradient blue-text"
                onClick={props.toggleModal}
              >
                Close
              </MDBBtn>
            ) : (
              <MDBBtn
                className="green"
                onClick={() => {
                  window.open(
                    props.apiServerHybrid +
                      "/Print/ORPrint?reporttype=deliveryreceipt&code=" +
                      props.code,
                    "_blank"
                  );
                }}
              >
                Print
              </MDBBtn>
            )}
          </form>
        </MDBCol>
      </MDBRow>

      <MDBModal backdrop={false} isOpen={modalDelete} toggle={deleteRecord}>
        <MDBModalHeader
          className="text-left black-text cloudy-knoxville-gradient"
          titleClass="w-100"
          tag="h5"
        ></MDBModalHeader>
        <MDBModalBody className="text-center">
          <MDBRow>
            <MDBCol size="3" className="text-center">
              <MDBIcon icon="trash-alt" size="5x" className="red-text" />
            </MDBCol>
            <MDBCol size="9" className="black-text text-center">
              <p></p>
              <p>Do you really want to delete this record?</p>
              <p className="text-center">
                <MDBBtn color="danger" onClick={confirmDelete}>
                  Yes
                </MDBBtn>
                <MDBBtn
                  className="cloudy-knoxville-gradient blue-text"
                  onClick={deleteRecord}
                >
                  Cancel
                </MDBBtn>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBModalBody>
      </MDBModal>

      <InfoBox
        errorMessage={errorMessage}
        isOpen={modalInfo}
        toggleModal={toggleInfoBox}
      />
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditExpensesMain;
